import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Mail, Facebook, Instagram, Youtube, Send } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { setConsent } from "@/lib/consent";

const LINKS = [["/", "Home"], ["/artisti", "Artisti"], ["/fornitori", "Fornitori"], ["/consigliati", "Consigliati"], ["/store", "Store"], ["/faq", "FAQ"], ["/registrati", "Iscrizione"]];
const SOCIAL = [[Facebook, "Facebook"], [Instagram, "Instagram"], [Youtube, "YouTube"]];
const LEGAL = [["/privacy", "Privacy"], ["/cookie-policy", "Cookie Policy"], ["/termini", "Termini e Condizioni"]];

const NewsletterBox = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("Iscrizione alla newsletter completata");
      setEmail("");
    } catch { toast.error("Inserisci un indirizzo email valido"); }
    setBusy(false);
  };
  return (
    <form onSubmit={submit} data-testid="newsletter-form">
      <div className="font-display font-semibold text-white mb-3">Iscriviti alla nostra newsletter</div>
      <div className="flex bg-white rounded-xl overflow-hidden">
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="La tua email" data-testid="newsletter-email"
          className="flex-1 min-w-0 px-4 py-3 text-sm text-[#0D2B5A] outline-none"/>
        <button disabled={busy} data-testid="newsletter-submit" aria-label="Iscriviti" className="bg-gold px-4 text-[#0D2B5A] hover:brightness-110 transition-[filter] disabled:opacity-50"><Send className="w-4 h-4"/></button>
      </div>
    </form>
  );
};

export default function Footer() {
  const { pathname } = useLocation();
  return (
    <footer className={`bg-aic-navy text-slate-200 border-t-4 border-gold ${pathname === "/" ? "" : "mt-24"}`} data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-14 grid gap-10 md:grid-cols-[1.3fr_1fr_auto_1.2fr] items-start">
        <div>
          <Link to="/" className="flex items-center gap-3 mb-4" data-testid="footer-logo">
            <img src="/logo-icon.png" alt="Artisti in Comune" className="w-14 h-14 object-contain bg-white rounded-xl p-1"/>
            <div className="font-logo text-xl font-bold text-white">Artisti <span className="text-gold">in</span> Comune</div>
          </Link>
          <p className="text-sm text-slate-300 leading-relaxed max-w-xs">Il portale istituzionale che unisce Pubblica Amministrazione, Imprese e Privati con Artisti e Fornitori di spettacolo.</p>
          <p className="text-xs text-slate-400 mt-4 flex items-center gap-2"><Mail className="w-4 h-4"/>info@artistincomune.it</p>
        </div>
        <ul className="grid grid-cols-2 gap-x-8 gap-y-2 text-sm" data-testid="footer-links">
          {LINKS.map(([to, l]) => <li key={to}><Link to={to} className="hover:text-gold transition-colors">{l}</Link></li>)}
        </ul>
        <div className="flex gap-3" data-testid="footer-social">
          {SOCIAL.map(([Icon, l]) => <span key={l} title={`${l} · presto disponibile`} aria-label={l} data-testid={`footer-social-${l.toLowerCase()}`}
            className="w-10 h-10 rounded-full border border-white/25 flex items-center justify-center text-white/80"><Icon className="w-4 h-4"/></span>)}
        </div>
        <NewsletterBox/>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 text-xs text-slate-300 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="flex flex-wrap items-center gap-3" data-testid="footer-legal">
            {LEGAL.map(([to, l], i) => <React.Fragment key={to}>{i > 0 && <span className="text-white/30">|</span>}<Link to={to} data-testid={`footer-legal-${to.slice(1)}`} className="hover:text-gold">{l}</Link></React.Fragment>)}
            <span className="text-white/30">|</span>
            <button type="button" onClick={() => setConsent(null)} data-testid="footer-cookie-prefs" className="hover:text-gold">Preferenze cookie</button>
          </div>
          <div className="text-center md:text-right">© 2026 Artisti in Comune · Tutti i diritti riservati · P.IVA [P.IVA]</div>
        </div>
      </div>
    </footer>
  );
}
